import React from 'react'

import { Section, Eyebrow, TrustLine } from '../../../components/ui'
import { useSelectors } from '../../../store'
import { washCountLabel } from '../../../lib/social-proof'

import './intro.css'

// THE TOP OF THE PAGE. The eyebrow, the H1, the promise and the facts line,
// which is deliberately the same four elements in the same order as
// pages/services/intro: a visitor who moves between the two pages should
// not feel they have changed site.
//
// WHAT WAS HERE BEFORE: <PageHeader title="FAQs" />, a 1,600px stock
// photograph behind the word "FAQs" in a band with two empty flanking divs.
// It is gone for three reasons and only the first is about taste. DESIGN.md
// §5: no image above the fold on a phone, because the H1 has to be the LCP
// element. §3: no `background-image` hero, and every <img> carries width and
// height for CLS, which that one does not. And "FAQs" is not a headline, it
// is a filename: it tells a reader nothing they did not know from clicking
// the link. The component stays in components/page-header because
// /privacy_policy and /terms_and_conditions still use it; those two pages are
// not rebuilt yet.
//
// NOTHING REPLACES THE PHOTOGRAPH, which is a decision rather than an
// omission, and the same one pages/services/intro made: the ten real washes
// in assets/images are already the whole of the home page's filmstrip and
// recent-work strip, and a third copy of the same frames one click later is
// decoration. A page of answers is allowed to begin with a question.

export const Intro = () => {
  // The live wash count from /api/v2/app_config, exactly as the hero and the
  // services intro read it. The fallback is the real total since 2016, not a
  // round number.
  // Null while SHOW_SOCIAL_PROOF is off (lib/social-proof.js), and the facts
  // line then states the year alone.
  const { config } = useSelectors()
  const washLabel = washCountLabel(config)

  return (
    <Section className="faq-intro">
      <Eyebrow>Mobile car valeting · London · Since 2016</Eyebrow>

      <h1 className="faq-intro-h1">Everything you need to know</h1>

      <p className="faq-intro-promise">
        If your answer is not here, message us on WhatsApp and one of us will answer.
      </p>

      <TrustLine
        className="faq-intro-trust"
        items={[washLabel ? `${washLabel} cars washed since 2016` : 'Valeting since 2016', 'Vetted and insured valeters', 'We bring our own water and power']}
      />
    </Section>
  )
}
